export default "__VITE_ASSET__CAP7UZea__"